import {
    FileListLoadingStatus,
    getRecentFilesViewState,
    getSpListViewStateData,
    isSpAbsent,
} from 'owa-group-files-hub-store';
import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import strings from 'owa-strings/owa-groups-strings';
import { getIsLightBaseTheme } from 'owa-theme';
import { Label } from 'office-ui-fabric-react/lib/components/Label';
import { observer } from 'mobx-react';
import * as React from 'react';

const styles = require('./RecentFilesEmptyOrErrorWithNoSP.scss');
const emptyColoredIcon = 'svg/colored/recentFilesEmpty.svg';
const emptyGrayIcon = 'svg/gray/recentFilesEmpty.svg';
const errorColoredIcon = 'svg/colored/recentFilesError.svg';
const errorGrayIcon = 'svg/gray/recentFilesError.svg';

// This component handles empty recent files and errors in recent files scenarios
// when the current tenant does not have a SharePoint site
@observer
export class RecentFilesEmptyOrErrorWithNoSP extends React.Component<{}, {}> {
    render(): JSX.Element {
        const spListViewState = getSpListViewStateData.get();
        if (!spListViewState) {
            return null;
        }

        if (isSpAbsent(spListViewState)) {
            // This is the target scenario: current group has no SharePoint site
            const state = getRecentFilesViewState.get();
            if (!state || state.isLoading) {
                return null;
            }

            const recentFilesIsEmpty =
                state.listStatus === FileListLoadingStatus.Success && state.files.length === 0;
            const errorsInRecentFiles = state.listStatus === FileListLoadingStatus.Failed;

            const pathToSvgIcon = this.getPathToSvgIcon(recentFilesIsEmpty, errorsInRecentFiles);
            const emptyOrErrorsStyle = this.getEmptyOrErrorsStyle(recentFilesIsEmpty);
            const emptyOrErrorsString = this.getEmptyOrErrorsString(recentFilesIsEmpty);

            // This boolean is true if either the recent files list is empty or there are errors in recent files
            // When this boolean is true we will render the svg icon and the warning/error message
            const shouldShowRecentFilesEmptyOrErrorWithNoSP =
                recentFilesIsEmpty || errorsInRecentFiles;
            if (shouldShowRecentFilesEmptyOrErrorWithNoSP) {
                return (
                    <div>
                        <Label id="recentsheader" className={styles.recentfilesHeader}>
                            {strings.fileshubRecentPanelHeader}
                        </Label>
                        <div
                            className={styles.recentFilesEmptyOrErrorWithNoSPContainer}
                            aria-label={emptyOrErrorsString}
                            tabIndex={0}>
                            <div className={styles.recentFilesEmptyOrError}>
                                <img
                                    className={styles.recentFilesEmptyOrErrorIcon}
                                    src={pathToSvgIcon}
                                />
                                <div className={emptyOrErrorsStyle}>{emptyOrErrorsString}</div>
                            </div>
                        </div>
                    </div>
                );
            } else {
                // The recent files succeed to load (neither empty nor failed)
                return null;
            }
        } else {
            // Do not render this component if it is not the target scenario
            return null;
        }
    }

    private getPathToSvgIcon(recentFilesIsEmpty: boolean, errorsInRecentFiles: boolean): string {
        let coloredOrGrayIcon = '';
        if (recentFilesIsEmpty) {
            coloredOrGrayIcon = getIsLightBaseTheme() ? emptyColoredIcon : emptyGrayIcon;
        } else if (errorsInRecentFiles) {
            coloredOrGrayIcon = getIsLightBaseTheme() ? errorColoredIcon : errorGrayIcon;
        }

        return getPackageBaseUrl() + coloredOrGrayIcon;
    }

    private getEmptyOrErrorsStyle(recentFilesEmpty: boolean): string {
        return recentFilesEmpty ? styles.recentFilesEmptyMessage : styles.recentFilesErrorMessage;
    }

    private getEmptyOrErrorsString(recentFilesEmpty: boolean): string {
        return recentFilesEmpty
            ? strings.fileshubRecentFilesEmpty
            : strings.fileshubRecentFilesError;
    }
}
